import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/canvas3d',
    name: 'Canvas3D',
    component: () => import('../views/demo/Canvas3D.vue')
  },
  {
    path: '/material2d',
    name: 'Material2D',
    component: () => import('../views/demo/Material2D.vue')
  },
  {
    path: '/material3d',
    name: 'Material3D',
    component: () => import('../views/demo/Material3D.vue')
  },
  {
    path: '/canvas2d',
    name: 'Canvas2D',
    component: () => import('../views/demo/Canvas2D.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router